import { enqueueSnackbar } from 'notistack'
import { useShallow } from 'zustand/react/shallow'

import { TournamentEvent } from '@img-arena/consoles-api-streaming'
import DownloadIcon from '@mui/icons-material/Download'
import { STORE_STATUS } from '@/constants/store'
import { useImportEventsTournamentStore } from '@/stores/importEventsTournament'

import { ImportEventsForm, importSingleEvent } from '../forms/ImportEventsForm/ImportEventsForm'
import { ActionsMenu } from '../table/actions'
import { ActionFormItem } from '../table/actions/ActionFormItem/ActionFormItem'
import { ActionImportEventsItem } from '../table/actions/ActionImportEventsItem/ActionImportEventsItem'
import { FilterableTable } from '../table/base'
import { TOURNAMENT_DETAILS_COLUMNS, TOURNAMENT_DETAILS_FILTERS } from './tournamentDetails.table'
import { isImportedTournament, isImportedTournamentEvent } from './utils'

const TABLE_ID = 'tournament-details-table'
export const NO_DATA_TEXT = 'Import Events table is empty'

export const TournamentDetailsTable = () => {
  const {
    currentTournament,
    data: events,
    isFetching,
    isLoading,
    fetchData
  } = useImportEventsTournamentStore(
    useShallow((state) => ({
      isLoading: state.status === STORE_STATUS.loading,
      isFetching: state.status === STORE_STATUS.fetching,
      data: state.data,
      currentTournament: state.tournament,
      fetchData: state.fetchData
    }))
  )

  if (!currentTournament) return

  const filteredExternalEvents = events.filter((event) => event.status !== 'Finished')

  return (
    <FilterableTable
      clientSideFilters
      clientSideSortAndPagination
      tableId={TABLE_ID}
      columns={TOURNAMENT_DETAILS_COLUMNS}
      filters={TOURNAMENT_DETAILS_FILTERS}
      loading={isLoading}
      fetching={isFetching}
      data={filteredExternalEvents}
      defaultSort={{ attribute: '$name', order: 'asc' }}
      rowActions={
        <ActionsMenu>
          {isImportedTournament(currentTournament) ? (
            <ActionImportEventsItem
              isActive={(row) => !isImportedTournamentEvent(row)}
              onClick={async (row) => {
                try {
                  await importSingleEvent(currentTournament, row)

                  fetchData(currentTournament.id)

                  enqueueSnackbar(`Successfully imported event: ${row.name}!`, {
                    variant: 'success'
                  })
                } catch (e) {
                  enqueueSnackbar(String(e), { variant: 'error' })
                  throw e
                }
              }}
            />
          ) : (
            <ActionFormItem
              overrideText="Import"
              icon={<DownloadIcon />}
              isActive={(row) => !isImportedTournamentEvent(row)}
              getForm={(row: TournamentEvent) => (
                <ImportEventsForm
                  data={{ data: row }}
                  tournament={currentTournament}
                  onSubmit={() => fetchData(currentTournament.id)}
                />
              )}
            />
          )}
        </ActionsMenu>
      }
      noDataMessage={NO_DATA_TEXT}
    />
  )
}
